import { IconButtonProps } from '@chakra-ui/react';
import { HiMenuAlt4 } from 'react-icons/hi';

import { useUIStore } from '$stores/ui';

import { SidebarButton } from './sidebar-button';

export function OpenSidebarButton(props: Omit<IconButtonProps, 'aria-label'>) {
  const { openSidebar } = useUIStore();

  function handleOpenSidebar() {
    openSidebar();
    if (typeof document !== 'undefined') {
      document.body.style.overflow = 'hidden';
    }
  }

  return (
    <SidebarButton
      {...props}
      aria-label="Abrir menu"
      icon={HiMenuAlt4}
      onClick={handleOpenSidebar}
    />
  );
}
